<template>
<div>
    <transition name="fade">
        <div v-if="performingRequest" class="loading">
            <p>Signing In..</p>
        </div>
    </transition>

    <transition name="fade">
        <div v-if="performingRequestForReset" class="loading">
            <p>Creating password reset link..</p>
        </div>
    </transition>

    <b-container fluid>
        <!---------------------------------->
        <!-- Top Message-->
        <!---------------------------------->
        <b-row>
            <b-col><h3 style="text-align:center; margin:5px; padding-top:10px; padding-bottom:10px">Beer For Your Taplist, Straight From The Brewery</h3></b-col>
        </b-row>
        
        <!---------------------------------->
        <!-- Top three columns from Brian -->
        <!---------------------------------->
        <b-row>
            <!-- First column -->
            <b-col md='4' style="background-color:#d9d9d9; ">
                <b-row>
                    <b-col>
                        <!-- Outer div -->
                        <div style="width:250px; margin:auto;">
                            <!-- Button -->
                            <div class="ksbutton" style="background-color:#294074; color:white; width:100%; border:1px solid #294074; border-radius:20px; margin-top:35px; cursor:pointer"
                                @click="goToCreateAccount">
                                <div style="padding-top:20px; font-size:20px; color:#c0c0c0; text-align:center">Here To</div>
                                <div style="font-size:30px; text-align:center; padding-bottom:20px"><strong>Buy</strong></div>
                            </div>
                            <br>
                            <table style="margin-bottom:25px">
                                <tr>
                                    <td style="vertical-align:top"><font-awesome-icon icon="globe-americas"/></td>
                                    <td><span style="">Discover beers and breweries</span></td>
                                </tr>
                                <tr>
                                    <td style="vertical-align:top"><font-awesome-icon icon="calculator"/></td>
                                    <td><span style="">Get instant pricing</span></td>
                                </tr>
                                <tr>
                                    <td style="vertical-align:top"><font-awesome-icon icon="hand-pointer" style="margin-right:20px"/></td>
                                    <td><span style="">Order online</span></td>
                                </tr>
                                
                            </table>
                        </div> 
                    </b-col>
                </b-row>
            </b-col>
            <!-- End of column -->

            <!-- Second column -->
            <b-col md='4' style="background-color:#bfbfbf; ">
                <b-row>
                    <b-col>
                        <!-- Outer div -->
                        <div style="width:250px; margin:auto;">
                            <!-- Button -->
                            <div  class="ksbutton" style="background-color:#912C60; color:white; width:100%; border:1px solid #912C60; border-radius:20px; margin-top:35px; cursor:pointer"
                                @click="goToCreateAccount">
                                <div style="padding-top:20px; font-size:20px; color:#c0c0c0; text-align:center">Here To</div>
                                <div style="font-size:30px; text-align:center; padding-bottom:20px"><strong>Sell</strong></div>
                            </div>
                            <br>
                            <table style="margin-bottom:25px">
                                <tr>
                                    <td style="vertical-align:top"><font-awesome-icon icon="envelope" style="margin-right:20px"/></td>
                                    <td><span style="">Connect with buyers</span></td>
                                </tr>
                                <tr>
                                    <td style="vertical-align:top"><font-awesome-icon icon="pen-nib"/></td>
                                    <td><span style="">Market with simple, effective tools</span></td>
                                </tr>
                                <tr>
                                    <td style="vertical-align:top"><font-awesome-icon icon="warehouse"/></td>
                                    <td><span style="">Manage inventory and orders</span></td>
                                </tr>
                            </table>
                        </div> 
                    </b-col>
                </b-row>
            </b-col>
            <!-- End of column -->
            
            <!-- Third column -->
            <b-col md='4' style="background-color:#a6a6a6; ">
                <b-row>
                    <b-col>
                        <!-- Outer div -->
                        <div style="width:250px; margin:auto;">
                            <!-- Button -->
                            <div  class="ksbutton" style="background-color:#78AB53; color:white; width:100%; border:1px solid #78AB53; border-radius:20px; margin-top:35px; cursor:pointer"
                            @click="goToLearnMore">
                                <div style="padding-top:20px; font-size:20px; color:#e6e6e6; text-align:center">Just Keg</div>
                                <div style="font-size:30px; text-align:center; padding-bottom:20px"><strong>Curious</strong></div>
                            </div>
                            <br>
                            <table style="margin-bottom:25px">
                                <tr>
                                    <td style="vertical-align:top"><font-awesome-icon icon="info" style="margin-right:20px; text-align:top; "/></td>
                                    <td><span style="">Not sure? Keg Seeker democratizes selling and buying for busy brewers, reps and buyers. <router-link to="/buyers" style="color:black"><u>Learn more</u></router-link></span></td>
                                </tr>
                            </table>
                        </div> 
                    </b-col>
                </b-row>
            </b-col>
            <!-- End of column -->
        </b-row>

        <!-- Next row for message -->
        <!--
        <b-row style="background-color:#369bc9; color:white; padding-top:10px; padding-bottom:10px; font-size:12px; text-align:center">
            <b-col>
                Keg Seeker is a Business to Business marketplace. Only businesses such as Breweries, Distributors, Restaurants, Pubs, Liquor Stores can be Keg Seeker members.
            </b-col>
        </b-row>
        -->

        <!-- Next row for message -->
        <b-row style="background-color:#8c8c8c; color:white; padding-top:20px; padding-bottom:20px; font-size:20px; text-align:center">
            <b-col>
                Not a member yet? <router-link to="/createaccount" style="color:white"><u><font-awesome-icon icon="user-plus" style="margin-left:10px; margin-right:5px"/> Join Our B2B Community</u></router-link> and tap into our growing selection of beers, seltzers, kombucha.
            </b-col>
        </b-row>

    </b-container>

    <b-container>
        <!-- Login form, only show in mobile. Desktop shows it in menu bar -->
        <b-row  class="container d-block d-md-none form-row">
            <b-col cols="12" style="font-size:15px; margin-top:20px; margin-left:17px"><span>Already have an account?</span></b-col>
        </b-row>
        <form class="container d-block d-md-none form-row">
            <div class="form-row">
                <div class="input-group col-md-3  col-lg-6" style="margin-top:10px;">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Email</span>
                    </div>
                    <input type="email" class="form-control" v-model.trim="loginForm.email"  placeholder="Email" aria-describedby="basic-addon1">
                </div>
                <div class="input-group col-md-3  col-lg-6 mx-auto" style="margin-top:10px;">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Password</span>
                    </div>
                    <input type="password" v-model.trim="loginForm.password"  @keyup.enter="login" class="form-control" placeholder="Password" aria-describedby="basic-addon1">
                </div>
            </div>
            <!-- Login and other buttons -->
            <div class='form-row' style="padding-bottom:10px">
                <div style="margin-top:10px; text-align:center; ">
                    <b-button class="m-md-2" variant="info" @click="login">
                        Login
                    </b-button>
                </div>
                <div  style="text-align:center; margin-left:10px; margin-top:20px; ">
                    <div style="color:grey">
                        <a @click="togglePasswordReset">Forgot Password?</a>
                    </div>
                </div>
            </div>
            
        </form>

        <!-- Reset password form -->
        <b-row>
            <b-col>
                <form v-if="showForgotPassword" @submit.prevent class="password-reset" style="margin-bottom:20px">
                    <hr>
                    <div v-if="!passwordResetSuccess" style="margin-top:10px">
                        <h4>Reset Password</h4>
                        <p>We will send you an email to reset your password</p>
                        <div class="input-group" style="margin-top:10px;">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Email</span>
                            </div>
                            <input type="email" class="form-control" v-model.trim="passwordForm.email"  aria-describedby="basic-addon1">
                        </div>

                        <button @click="resetPassword" class="button" style="margin-top:10px">Reset Password</button>
                    </div>
                    <div v-else>
                        <h2>Reset Password Email Link Sent</h2>
                        <h4>Check your email for a link to reset your password</h4>
                    </div>
                    <hr>
                </form>
            </b-col>
        </b-row>

        <!-- Login error message -->
        <b-row>
            <b-col>
                <transition name="fade">
                    <div v-if="errorMsg !== ''" class="error-msg">
                        <p>{{ errorMsg }}</p>
                    </div>
                </transition>
            </b-col>
        </b-row>

        <!-- App icons -->
        <!--
        <b-row style="margin-top:20px">
            <b-col style="">
                <a href="https://apps.apple.com/us/app/kegseeker/id1516879539"><img src="../assets/app_store_icon.png" width="150"></a>
                <a href="https://play.google.com/store/apps/details?id=com.kegseeker.kegseeker"><img src="../assets/play_store_icon.png" width="150"></a>
            </b-col>

        </b-row>
        -->

        <!--- Carousel with brewery logos. Don't show breweries which are part of distributors -->
        <b-row class="d-none d-md-block" >
            <b-col>
                <h4 style="margin-top:20px">Our Partners</h4>
            </b-col>
        </b-row>
            <b-row  class="d-none d-md-block"  style="margin-top:0px; margin-left:0px; margin-right:0px; background-color:#f2f2f2; height:270px">
                <b-col>
                    <carousel :perPageCustom="[[750, 3],[1070, 4], [1100, 10]]"  :mouse-drag="false" 
                    :autoplay="true" :loop="true" :autoplayHoverPause="true" :autoplayTimeout="6000" :navigationEnabled="true" 
                    paginationColor="#fff">
                        <template  v-for="(brewer, index) in brewersList" >
                            <slide :key="index" v-if="brewer.logoFileThumbnailURL&&!brewer.distbrewerid">
                                <b-card style="width:110px; height:180px; margin-top:20px;">
                                    <div style="height:100px">
                                    <img  style="margin-left:0px" :src="brewer.logoFileThumbnailURL" width="75; height:75"  fluid alt="Logo image" >
                                    </div>
                                    <div style="border-bottom: 2px solid #f3d087 "></div>
                                    <div style="font-size:8px; text-align:center; padding-top:5px">{{brewer.company}}</div>
                                </b-card>
                            </slide>
                        </template>
                    </carousel>
                </b-col>
            </b-row>


        <!-- SD Reader -->
        <hr>
        <b-row>
            <b-col>
                <h4 style="color:#2e5189">Keg Seeker in the news</h4>
            </b-col>
        </b-row>
        <table>
            <tbody>
                <tr @click="goToSdReader" style="cursor:pointer">
                    <td>
                        <img src="../assets/sandiegoreader.png" width="150">
                    </td>
                    <td>
                        <div style="margin-left:20px">
                            <h4>Keg Seeker seeks to modernize wholesale beer sales</h4>
                            <div style="color:#737373">Local app can help beer buyers improve their taplists</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="12">
                        <hr>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Testimonials -->
        <b-row>
            <b-col>
                <h4 style="margin-top:20px; color:#2e5189">See what people are saying about Keg Seeker</h4>
            </b-col>
        </b-row>

        <b-row style=" font-size:14px">
            <b-col>
                <table style="margin-top:0px">
                    <tbody>
                        <tr>
                            <td colspan="12">
                                <hr>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <img  width="75px" src="../assets/brewery_logo_eppig.jpg"/>
                            </td>
                            <td>
                                <div style="margin-left:20px">
                                    Having been both a Sales Rep. and a beer buyer, I find the ease, accessibility and functionality of Keg Seeker on point. It enables me to, in either role, streamline my job and be more productive.
                                </div>
                                <div style="padding-left:20px"><strong><i>- Eppig Brewing</i></strong></div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="12">
                                <hr>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <img  width="75px" src="../assets/brewery_logo_latchkey.jpg"/>
                            </td>
                            <td>
                                <div style="margin-left:20px">
                                    We love it, use it all the time, every week. We discovered the new feature that you can email the buyers. It’s something we take advantage of every week. New people responding to us who don’t know us, and we don’t know them. Doing cold orders and asking for samples.
                                </div>
                                <div style="padding-left:20px"><strong><i>- Latchkey Brewing</i></strong></div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="12">
                                <hr>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <img  width="75px" src="../assets/logo_roses.png"/>
                            </td>
                            <td>
                                <div style="margin-left:20px">
                                    Find new beers/breweries that may not know about us, therefore I don't see their reps. Being able to search by style. We only have 10 lines, so I try to keep a variety of styles. Sometimes I have time to order beer at 9:00pm!
                                </div>
                                <div style="padding-left:20px"><strong><i>- Rose's Tasting Room</i></strong></div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="12">
                                <hr>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <img  width="75px" src="../assets/logo_nomad_donuts.png"/>
                            </td>
                            <td>
                                <div style="margin-left:20px">
                                    So far so great!  We’re pretty small and still trying to establish our beer and wine biz so Keg Seeker allows me to get great local beer from multiple breweries without having to work with multiple distributors
                                </div>
                                <div style="padding-left:20px"><strong><i>- Nomad Donuts</i></strong></div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="12">
                                <hr>
                            </td>
                        </tr>
                        
                    </tbody>
                </table>
            </b-col>
        </b-row>

        <footer><pagefooter/></footer>
        </b-container>
</div>
</template>

<script>
    import { mapState } from 'vuex'
    const fb = require('../firebaseConfig.js')
    import {timeConverterDateOnly} from './Myfunctions'
    import Pagefooter from './Pagefooter'
    import { Carousel, Slide } from 'vue-carousel';

    export default {
        components: {
            Pagefooter,
            Carousel,
            Slide,
        },
        data() {
            return {
                windowWidth:0,
                loginForm: {
                    email: '',
                    password: ''
                },
                signupForm: {
                    name: '',
                    company: '',
                    email: '',
                    password: '',
                    isbrewer:0,
                    street1:'',
                    street2:'',
                    city:'',
                    state:'',
                    zip:'',
                    radius:'',
                    phone:'',
                    favorites:[]
                },
                passwordForm: {
                    email: ''
                },
                showLoginForm: true,
                showForgotPassword: false,
                passwordResetSuccess: false,
                performingRequest: false,
                performingRequestForReset:false,
                errorMsg: '',
                theUserID: '',
                acceptedTerms:false,
                acceptedPub:false,
                acceptedBrewer:false,
                showTermsWarning:false,
                genericBeersList:[],
                genericBrewersList:[],
                brewersList:[],
            }
        },
        computed: {
            ...mapState(['isBrewer', 'userProfileStatus', 'userProfile', 'allBrewersList', 'allExistingBeers', 'selectedConsumerWebsite', 'allowConsumers', 'countEmails', 'currentUser']),
            beersList(){

            },
            getBreweryData(){
                //var data=["Data 0","Data 1", "Data 2","Data 3","Data 4","Data 5","Data 6","Data 7","Data 8","Data 9"]
                var data = this.allBrewersList
                var componentWidth=120
                var leftColumnWidth=500
                var widthOfDisplay=this.windowWidth-leftColumnWidth
                var columnsInRow=Math.floor(widthOfDisplay/componentWidth)
                var numberOfRows=0
                //Needed to catch columnsInRow=0 on initial load
                if(columnsInRow>0)
                    numberOfRows=Math.ceil(data.length/columnsInRow)
                var rowColumnArray=[]

                //Iterate over all rows
                for (var rowNumber=0; rowNumber<numberOfRows; rowNumber++){
                    //Iterate over columns
                    var columnArray=[]
                    for (var columnNumber=0; columnNumber<columnsInRow; columnNumber++){
                        
                        //Iterate over columns
                        var dataNumber=rowNumber*columnsInRow+(columnNumber)
                        if(dataNumber<data.length){
                            columnArray.push(data[dataNumber])
                        }
                        //End of column array
                    }
                    //Add to row array
                    rowColumnArray.push(columnArray)
                    //End of row array
                }
                return rowColumnArray

            },
        },

        watch: {
            userProfileStatus(newValue, oldValue) {
                /*
                if (newValue){
                    this.performingRequest = false
                    if(this.userProfile.isbrewer==1) this.$router.push('/brewerdashboard')
                    else if(this.userProfile.isbrewer==2) this.$router.push('/distributorinventory')
                    else this.$router.push('/allbeers')
                    
                }*/
            },
        },

        methods: {

            viewBrewerProfile(brewerId,brewer){

                this.$router.push({ path: 'breweryprofile', query: { brewerId: brewerId }})
            },


            goToCreateAccount() {
                this.$router.push({name:'createaccount'})
                this.errorMsg = ''
            },
            goToLearnMore() {
                this.$router.push({name:'buyers'})
                this.errorMsg = ''
            },

            togglePasswordReset() {
                this.$router.push({path:'/forgotpassword'})
            },
            login() {
                this.performingRequest = true
                this.$store.commit('setUserProfileStatus',0)

                fb.auth.signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password).then(user => {
                    this.$store.commit('setCurrentUser', user.user)
                    this.theUserID = user.user.uid
                        
                }).catch(err => {
                    console.log(err)
                    this.performingRequest = false
                    this.errorMsg = err.message
                })
            },
            resetPassword() {
                this.performingRequestForReset = true

                fb.auth.sendPasswordResetEmail(this.passwordForm.email).then(() => {
                    this.performingRequestForReset = false
                    this.passwordResetSuccess = true
                    this.passwordForm.email = ''
                }).catch(err => {
                    console.log(err)
                    this.performingRequestForReset = false
                    this.errorMsg = err.message
                })
            },
            //Exploring beverages without signing in 
            clickedExplore(){
                this.$router.push('/allbeersnoauth')

            },
            onResize() {
                this.windowWidth = window.innerWidth
            },

            //User selected consumer
            selectedConsumer(){
                
                window.open("https://consumer.kegseeker.com", "_blank");
            },
            //User selected business
            selectedBusiness(){
                this.$bvModal.hide("modal-consumer")

            },

            //SD reader link
            goToSdReader(){
                window.open("https://www.sandiegoreader.com/news/2021/feb/26/keg-seeker-seeks-modernize-wholesale-beer-sales/",  "_blank")
            },

            //Fetch brewers
            fetchBrewersList(){
                this.brewersList = []

                //First find brewers that deliver to this zipcode
                fb.usersCollection.where('isbrewer','>=',1).where("counties", "array-contains", "San Diego").get().then(docs => {
                    docs.forEach(doc => {
                        var brewerData = doc.data()
                        var logoURL
                        if(brewerData.logoFileThumbnailURL) logoURL = brewerData.logoFileThumbnailURL
                        else logoURL = ''
                        var brewerObject = {uid: doc.id, company: brewerData.company, logoFileThumbnailURL:logoURL, email:brewerData.email}
                        this.brewersList.push(brewerObject) 
                        
                    })
                    })

                    .then(res => {
                        if (this.brewersList.length<=0 ) this.nothingFound = true
                        else this.nothingFound=false
                        function shuffleArray(array) {
                            for (let i = array.length - 1; i > 0; i--) {
                                const j = Math.floor(Math.random() * (i + 1));
                                [array[i], array[j]] = [array[j], array[i]];
                            }
                            return array
                        }
                        this.brewersList=shuffleArray(this.brewersList)
                        })
            },
        },
        watch: {
            windowWidth(newWidth, oldWidth) {

            }
        },

        mounted(){

            this.$store.dispatch('setAppOptions');

            //For getting logos for first page
            //if(this.allBrewersList.length<=0) this.$store.dispatch('fetchAllBrewersList')

            this.windowWidth = window.innerWidth
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })
            this.fetchBrewersList()

        },
        beforeDestroy() { 
            window.removeEventListener('resize', this.onResize); 
        },
        
    }
</script>

<style>
.my-col2{
    border:10px solid white;
    background: linear-gradient(to right, #30A0EE 0%, #30A0EE 50%, #fff 50%, #fff);
}

.loginlefttitle{
    color: white
    
}

.beerTitleFrontPage{
    color:#480000;
}

.beerDescriptionFrontPage{
    color:#F7882F;
}
.accountquestions{
    border:10px solid white;
    background: linear-gradient(to right, #30A0EE 0%, #30A0EE 50%, #fff 50%, #fff);
}

.loginpagecard{
    background:black;
}

.messageholder{
    background-image: url("../assets/tap_handle_blurred2_small.png");
    padding:0px;
    margin:0px;
}
.ksbutton:hover {
    box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.25);
}

</style>
